<template>
    <div class="info-of-vacancies">
        <main-panel v-if=" $route.params.path==null"
            >
            <template v-slot:header>
                <h2>{{$route.name}}</h2>
            </template>
        </main-panel>
        <section class="frame-padding">
            <div>
                 <input-ms placeholder="Поиск" class="" v-model="searchText" @click="onSearch = !onSearch"></input-ms>
            </div>
            <div>
                <tols-admin v-if="admin" type-tols="HR"  :params="[hr.text,hr]"></tols-admin>
                <h3>
                    {{hr.text}} {{hr.tel}} {{hr.FIO}}
                </h3>
            </div>
            <component 
                :params="[searchText]"
                :search="onSearch"
                :admin="admin"
                :typeTols="'skeleVacancies'"
                :is="'skeleVacancies'"
            /> 
<!--item.component_name
                     v-for = "item in skeleton" 
                    :key="item.id" 
                    :id="item.id" 
                    :admin="admin"
                    :params="item.params"
                    :header="item.header"
                    :url="item.url" -->
        </section>
    </div>
    
</template>
<script>
import components from '@/mixins/components.mixin.js'
import mainPanel from '../components/main/mainPanel.vue';
// import panelMs from '../components/common/panelMs.vue';
import inputMs from '../components/common/inputMs.vue';
import tolsAdmin from '../components/admin/tolsAdmin.vue'
import axios from 'axios'; 
export default{
    mixins:[components],
    components:{
        tolsAdmin,
        mainPanel,
        // panelMs,
        inputMs,
    },
    mounted(){
        // this.getSkeleton(this.$route.fullPath) 
        // this.getVacancy()
        axios
            .get('https://mosp51.ru/api/hr')
            .then(response=>{
                this.hr = response.data
            })
        axios
            .get("https://mosp51.ru/api/login")
            .then(response=>{
                 console.log( response.data,'username')
                if (response.data.username){
                    this.admin = true
                } else {
                    this.admin = false
                }
            })    
    },
    methods:{
        // getVacancy(searchText = ''){
        //      let searchStr = '?'
        //     searchStr +=searchText!=''?'searchText='+searchText+'&':''

        //     axios
        //         .get('https://mosp51.ru/api/vacancy'+searchStr)
        //         .then(response=>{
        //             this.vacancy = response.data
        //         })
        // },
        // templateArea(){
        //     let template = ''
        //     let templateBuff = ''
        //     let j = 1
        //     for (let i=1;i<=this.vacancy.length;i++){
        //         templateBuff+="A"+i+' '
        //         console.log(templateBuff)
        //         console.log(i,j)
        //         if (this.vacancy.length%2 !== 0 && j == 1){
        //             i--
        //             console.log(i)
        //         }
        //         if (j%2==0||i==this.vacancy.length){
        //             template+='"'+templateBuff.trim()+'"'
        //             templateBuff = '';
        //         }
        //         j++
        //     }
        //     return template;
        // }
    },
    data(){
        return{
            searchText:'',
            onSearch:false,
            vacancy:[],
            hr:{},
            admin:false
        }
    }
}
</script>
<style>
.info-of-vacancies .frame-padding>div>h3{
    font-size: 26px;
    font-weight: 501;
    color: #0D3041;
    margin: 40px 0;
}
.info-of-vacancies .search-ms___panel_input{
    width:644px;
}
.info-of-vacancies .frame-padding:last-child{
    margin-bottom: 100px;
}
.info-of-vacancies .vacancies__panel{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    gap: 32px;
}

.info-of-vacancies .vacancies__panel .panel {
    padding: 32px
}
.info-of-vacancies .vacancies__panel h3,
.info-of-vacancies .vacancies__panel p,
.info-of-vacancies .vacancies__panel li{
    font-size: 16px;
}

.info-of-vacancies .vacancies__panel p{
    margin-bottom: 16px;
}
.info-of-vacancies .vacancies__panel  ul{
    padding: 0;
    margin:0;
}
@media (max-width: 1000px){
    .info-of-vacancies .vacancies__panel{
        display: flex;
        flex-direction: column;
    }
}
</style>